import { render, staticRenderFns } from "./recordDetail.vue?vue&type=template&id=5cd5d87e&scoped=true&"
import script from "./recordDetail.vue?vue&type=script&lang=js&"
export * from "./recordDetail.vue?vue&type=script&lang=js&"
import style0 from "./recordDetail.vue?vue&type=style&index=0&id=5cd5d87e&lang=scss&scoped=true&"
import style1 from "./recordDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd5d87e",
  null
  
)

export default component.exports